import React from "react";
import {GraphQlSelect} from "./GraphQlSelect";
import {useClientSubTypeQueryQuery} from "../../generated/graphql";
import {GraphQlSelectId} from "./GraphQlSelectId";
import { useDaybookContext } from "../../contexts/Daybook/DayBookContext";

export const ClientSubTypeSelect = (props) => {
    const query = useClientSubTypeQueryQuery();
    const config = useDaybookContext();
    const originalData = query.data?.clientSubTypes?.data;
    if (query.loading || !originalData) {
        return <p>Loading...</p>;
      }
    const filterConditions = (item) => {
        // Exclude items where names are below as per Kevin Request. This approach is used because trashed soft delete is not working somehow.
        return item.name !== 'Gigs & Tours' && item.name !== 'Festivals & Events' && item.name !== 'Health&Beauty' && item.name !== 'Streaming';
      };
    const filteredData = originalData?.filter(filterConditions);
    console.log("filteredDataClientSubtype", filteredData)
    if(config?.siteTitle == 'Daybook') {
      return props.valueIsId ? (
        <GraphQlSelectId
          queryResult={{ data: { clientSubTypes: { data: filteredData } } }}
          {...props}
          labelField="name"
        />
      ) : (
        <GraphQlSelect
          queryResult={{ data: { clientSubTypes: { data: filteredData } } }}
          {...props}
          labelField="name"
        />
      );
    }
    else {
      return props.valueIsId?<GraphQlSelectId queryResult={query} {...props}  labelField="name" />:<GraphQlSelect queryResult={query} {...props}  labelField="name" />;
    }
     
}

